module.exports = __webpack_public_path__ + "img/sgws-logo.4297a096.svg";